function toDateStr(val) {
  if (!val) return null
  const raw = val && typeof val === 'object' ? val.utc : String(val)
  return raw ? raw.split('T')[0].split(' ')[0] : null
}

function getTodayStr() {
  const now = new Date()
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
}

export function getCampaignStatus(campaign) {
  const todayStr = getTodayStr()
  const start = toDateStr(campaign.start_date)
  const end = toDateStr(campaign.end_date)

  if (start && todayStr < start) return { label: 'Not started', dotClass: 'bg-yellow-300' }
  if (end && todayStr > end) return { label: 'Finished', dotClass: 'bg-gray-400' }
  return { label: 'Active', dotClass: 'bg-rb-green' }
}

export function isActiveCampaign(campaign) {
  return getCampaignStatus(campaign).label === 'Active'
}

// Phase dot classes match the existing design system (bg-rb-phase-*-dot in tailwind).
export const PHASE_DOT_CLASS = {
  start: 'bg-rb-phase-start-dot',
  main: 'bg-rb-phase-main-dot',
  end: 'bg-rb-phase-end-dot',
  not_started: 'bg-gray-300 dark:bg-gray-500',
}

export const PHASE_LABEL = {
  start: 'Start',
  main: 'Main',
  end: 'End',
  not_started: 'Not started',
}

// Returns the phase to display for a campaign:
// 1. Active — today falls within a phase's date range.
// 2. Past — all phases ended; returns the most recently ended one.
// 3. Not started — all phases are in the future; returns a synthetic marker.
// Returns null only when the campaign has no phase data at all.
export function getCurrentPhase(campaign) {
  const phases = campaign.project_phases || []
  if (!phases.length) return null

  const todayStr = getTodayStr()

  const active = phases.find(
    (p) => p.start_date && p.end_date && todayStr >= p.start_date && todayStr <= p.end_date,
  )
  if (active) return active

  const pastPhases = phases
    .filter((p) => p.end_date && todayStr > p.end_date)
    .sort((a, b) => b.end_date.localeCompare(a.end_date))
  if (pastPhases.length) return pastPhases[0]

  // All phases are in the future
  const firstUpcoming = phases
    .filter((p) => p.start_date)
    .sort((a, b) => a.start_date.localeCompare(b.start_date))[0]
  return { phase: 'not_started', start_date: firstUpcoming?.start_date ?? null, end_date: null }
}
